<div class="p-grid w-100">
	<div class="p-col-12 p-md-4">
		<div class="d-flex flex-column card">
			<div class="display-10">cost</div>
			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="4rem"></p-skeleton>
			<div class="display-6 d-flex flex-column" *ngIf="metrics.loadComplete">
				<div class="ms-2">
					{{ currentDaySalesSummary?.laborCost | currency }}
				</div>

				<div *ngIf="metrics.laborCostPercent < 0" class="fl-text-success display-14 mt-auto ms-2">
					{{ metrics.laborCostPercent | percent }} <fa-icon [icon]="['fas', 'down']"></fa-icon> last {{ metrics.recordsRemaining }} days
				</div>
				<div *ngIf="metrics.laborCostPercent === 0" class="fl-text-secondary display-14 mt-auto ms-2">
					{{ metrics.laborCostPercent | percent }} <fa-icon [icon]="['fas', 'hyphen']"></fa-icon> last {{ metrics.recordsRemaining }} days
				</div>
				<div *ngIf="metrics.laborCostPercent > 0" class="fl-text-danger display-14 my-auto ms-2">
					{{ metrics.laborCostPercent | percent }} <fa-icon [icon]="['fas', 'up']"></fa-icon> last {{ metrics.recordsRemaining }} days
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-4">
		<div class="d-flex flex-column card">
			<div class="display-10">percent</div>
			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="4rem"></p-skeleton>
			<div class="display-6 d-flex flex-column" *ngIf="metrics.loadComplete">
				{{ currentDaySalesSummary?.laborPercentage | percent }}
				<div *ngIf="metrics.laborPercentPercent < 0" class="fl-text-success display-14 mt-auto ms-2">
					{{ metrics.laborPercentPercent | percent }} <fa-icon [icon]="['fas', 'down']"></fa-icon> last {{ metrics.recordsRemaining }} days
				</div>
				<div *ngIf="metrics.laborPercentPercent === 0" class="fl-text-secondary display-14 mt-auto ms-2">
					{{ metrics.laborPercentPercent | percent }} <fa-icon [icon]="['fas', 'hyphen']"></fa-icon> last {{ metrics.recordsRemaining }} days
				</div>
				<div *ngIf="metrics.laborPercentPercent > 0" class="fl-text-danger display-14 my-auto ms-2">
					{{ metrics.laborPercentPercent | percent }} <fa-icon [icon]="['fas', 'up']"></fa-icon> last {{ metrics.recordsRemaining }} days
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-4">
		<div class="d-flex flex-column card">
			<div class="display-10">overtime</div>
			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="4rem"></p-skeleton>
			<div class="display-6 d-flex flex-column" *ngIf="metrics.loadComplete">
				{{ metrics.overtime | currency }}
				<div *ngIf="metrics.overtimePercent < 0" class="fl-text-success display-14 mt-auto ms-2">
					{{ metrics.overtimePercent | percent }} <fa-icon [icon]="['fas', 'down']"></fa-icon> last {{ metrics.recordsRemaining }} days
				</div>
				<div *ngIf="metrics.overtimePercent === 0" class="fl-text-secondary display-14 mt-auto ms-2">
					{{ metrics.overtimePercent | percent }} <fa-icon [icon]="['fas', 'hyphen']"></fa-icon> last {{ metrics.recordsRemaining }} days
				</div>
				<div *ngIf="metrics.overtimePercent > 0" class="fl-text-danger display-14 my-auto ms-2">
					{{ metrics.overtimePercent | percent }} <fa-icon [icon]="['fas', 'up']"></fa-icon> last {{ metrics.recordsRemaining }} days
				</div>
			</div>
		</div>
	</div>
</div>

<div class="p-grid">
	<div class="p-col-12 p-md-3">
		<div class="d-flex flex-column card mt-1">
			<div class="display-10">by Job</div>
			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="10rem"></p-skeleton>
			<canvas baseChart [data]="laborDoughnut.data" [options]="laborDoughnut.options" [type]="'doughnut'" width="100%"></canvas>
		</div>
	</div>
	<div class="p-col-12 p-md-6">
		<div class="d-flex flex-column card mt-1">
			<div class="display-10">by hour</div>
			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="10rem"></p-skeleton>
			<canvas baseChart [data]="laborByHour.data" [options]="laborByHour.options" [type]="'line'" width="100%" height="45rem"></canvas>
		</div>
	</div>
	<div class="p-col-12 p-md-3">
		<div class="d-flex flex-column card h-100">
			<div class="display-10">on clock</div>
			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="4rem"></p-skeleton>
			<div class="p-grid" *ngIf="metrics.loadComplete">
				<div class="col-3 display-6">
					{{ metrics.onClockEmployees }}
				</div>
				<div class="col-9 display-14">
					<ng-container *ngFor="let job of metrics.onClockEmployeeList">
						<div>{{ job.count }} - {{ job.name }}</div>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</div>
